import Loader from 'Root/Loader'

const FetchMoreLoading = () => (
  <div className="text-center p-5 w-full">
    <Loader className="h-6 w-6 text-indigo-700 align-middle m-auto" />
  </div>
)

export default FetchMoreLoading
